export function getMeta(document: Document, name: string): null | string {
  const el = document.querySelector(`meta[name="${name}"]`);
  return el && el.getAttribute('content');
}
